// extracted by mini-css-extract-plugin
export default {"industryModel":"styles_industryModel__docPU","boxModel":"styles_boxModel__hYaxF","cross":"styles_cross__YUkbh"};